import React from 'react';
import PropTypes from 'prop-types';
import { Grid, Slide, Grow } from '@material-ui/core';
import ApplicationContentItem from '../ApplicationContentItem';

const ApplicationContent = ({ animation, data, active, onBookMark, bookmarks, preview }) => {
  if (preview) {
    return <Grid container spacing={2} style={{ flexWrap: "nowrap", overflowX: "auto" }}>
      {data.map((item, index) => (
        <Grid key={item.id} item style={{ maxWidth: 400 }} >
          <ApplicationContentItem {...item} active={active} onBookMark={onBookMark} bookmarked={bookmarks?.includes(item.id)} />
        </Grid>
      ))}
    </Grid>
  }
  return (
    <div>
      <Grid container spacing={4}>
        {data.map((item, index) => (
          animation == 'slide' ?
            <Slide key={item.id} direction="up" in={true} mountOnEnter unmountOnExit timeout={index * (1000 / (index + 1))}>
              <Grid item xs={12} sm={6} md={4}>
                <ApplicationContentItem {...item} active={active} onBookMark={onBookMark} bookmarked={bookmarks?.includes(item.id)} />
              </Grid>
            </Slide> :
            <Grow key={item.id} in={true} style={{ transformOrigin: '0 0 0' }}>
              <Grid item xs={12} sm={6} md={4}>
                <ApplicationContentItem {...item} active={active} onBookMark={onBookMark} bookmarked={bookmarks?.includes(item.id)} />
              </Grid>
            </Grow>
        ))}
      </Grid>
    </div>
  );
};

ApplicationContent.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.string.isRequired,
      onConnect: PropTypes.func,
    }),
  ),
  animation: PropTypes.any,
  active: PropTypes.bool,
  onBookMark: PropTypes.func,
  bookmarks: PropTypes.any,
  preview: PropTypes.any
};

export default ApplicationContent;
